import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentStatus, Statuses } from 'src/app/modules/shared/statuses';

@Component({
    selector: 'app-document-status',
    styleUrls: ['./document-status.component.scss'],
    template: `
    <div *ngIf="editable; else readonly">
      <p-dropdown
        [options]="statusOptions"
        [ngModel]="status"
        (onChange)="onValueChange($event.value)"
        placeholder="Select a Status"
        appendTo="body"
        class="status-dropdown"
      >
        <ng-template pTemplate="selectedItem">
          <div *ngIf="status">
            <ng-container [ngSwitch]="status">
              <p-chip
                *ngSwitchCase="DocumentStatus.NotReviewed"
                [label]="status"
                styleClass="mr-2"
              ></p-chip>
              <p-chip
                *ngSwitchCase="DocumentStatus.UnderReview"
                [label]="status"
                styleClass="mr-2 red-chip"
              ></p-chip>
              <p-chip
                *ngSwitchCase="DocumentStatus.Reviewed"
                [label]="status"
                styleClass="mr-2 orange-chip"
              ></p-chip>
              <p-chip
                *ngSwitchCase="DocumentStatus.Final"
                [label]="status"
                styleClass="mr-2 green-chip"
              ></p-chip>
            </ng-container>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <ng-template #readonly>
      <ng-container [ngSwitch]="status">
        <p-chip
          *ngSwitchCase="DocumentStatus.NotReviewed"
          [label]="status"
          styleClass="mr-2"
        ></p-chip>
        <p-chip
          *ngSwitchCase="DocumentStatus.UnderReview"
          [label]="status"
          styleClass="mr-2 red-chip"
        ></p-chip>
        <p-chip
          *ngSwitchCase="DocumentStatus.Reviewed"
          [label]="status"
          styleClass="mr-2 orange-chip"
        ></p-chip>
        <p-chip
          *ngSwitchCase="DocumentStatus.Final"
          [label]="status"
          styleClass="mr-2 green-chip"
        ></p-chip>
      </ng-container>
    </ng-template>
  `,
})
export class DocumentStatusComponent {
  @Input() status: string;
  @Input() editable: boolean;
  @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();
  public statusOptions = Statuses.documentStatuses;
  public DocumentStatus = DocumentStatus;

  constructor() {}

  onValueChange(status: string) {
      this.selectionChange.emit(status);
  }
}
